
import { BaseYcState, RegisterYCState } from '@yourcause/common/state';

@RegisterYCState()
export class EmailCommunicationState extends BaseYcState {
  readonly currentUnsubscribedEmailClassIds: number[];
  readonly email: string;
}
